<div class="modal-header">
  <h4 class="modal-title fw-bold">
    <i class="fa fa-horse me-3 text-primary"></i>
    {{ horse.name }}
  </h4>
  <button type="button" class="btn-close" (click)="close()"></button>
</div>

<div class="modal-body">
  <!-- Horse Images -->
  @if (hasImages()) {
    <div class="horse-images-section mb-6">
      <div class="row g-3">
        @if (horse.image_url) {
          <div class="col-md-4">
            <div class="horse-image-card" (click)="openImage(horse.image_url)">
              <img [src]="horse.image_url" [alt]="horse.name" class="horse-image" />
              <div class="image-label">
                <i class="fa fa-camera me-2"></i>
                {{ 'horseDetails.profilePhoto' | translate }}
              </div>
            </div>
          </div>
        }
        @if (horse.pedigree_image_url) {
          <div class="col-md-4">
            <div class="horse-image-card" (click)="openImage(horse.pedigree_image_url)">
              <img [src]="horse.pedigree_image_url" [alt]="'Pedigree'" class="horse-image" />
              <div class="image-label">
                <i class="fa fa-scroll me-2"></i>
                {{ 'horseDetails.pedigree' | translate }}
              </div>
            </div>
          </div>
        }
        @if (horse.vaccination_card_url) {
          <div class="col-md-4">
            <div class="horse-image-card" (click)="openImage(horse.vaccination_card_url)">
              <img [src]="horse.vaccination_card_url" [alt]="'Vaccination Card'" class="horse-image" />
              <div class="image-label">
                <i class="fa fa-syringe me-2"></i>
                {{ 'horseDetails.vaccinationCard' | translate }}
              </div>
            </div>
          </div>
        }
      </div>
    </div>
  }

  <!-- Horse Details -->
  <div class="horse-details-grid">
    <!-- Basic Info -->
    <div class="details-section">
      <h6 class="section-title">
        <i class="fa fa-info-circle me-2"></i>
        {{ 'horseDetails.basicInfo' | translate }}
      </h6>
      <div class="details-list">
        <div class="detail-row">
          <span class="detail-label">{{ 'horseDetails.name' | translate }}</span>
          <span class="detail-value">{{ horse.name || '-' }}</span>
        </div>
        <div class="detail-row">
          <span class="detail-label">{{ 'horseDetails.breed' | translate }}</span>
          <span class="detail-value">{{ horse.breed || '-' }}</span>
        </div>
        <div class="detail-row">
          <span class="detail-label">{{ 'horseDetails.color' | translate }}</span>
          <span class="detail-value">{{ horse.color || '-' }}</span>
        </div>
        <div class="detail-row">
          <span class="detail-label">{{ 'horseDetails.gender' | translate }}</span>
          <span class="detail-value">{{ getGenderLabel(horse.gender) }}</span>
        </div>
        <div class="detail-row">
          <span class="detail-label">{{ 'horseDetails.dateOfBirth' | translate }}</span>
          <span class="detail-value">{{ formatDate(horse.date_of_birth) }}</span>
        </div>
        <div class="detail-row">
          <span class="detail-label">{{ 'horseDetails.age' | translate }}</span>
          <span class="detail-value">{{ getAge() }}</span>
        </div>
      </div>
    </div>

    <!-- Identification -->
    <div class="details-section">
      <h6 class="section-title">
        <i class="fa fa-id-card me-2"></i>
        {{ 'horseDetails.identification' | translate }}
      </h6>
      <div class="details-list">
        <div class="detail-row">
          <span class="detail-label">{{ 'horseDetails.passportId' | translate }}</span>
          <span class="detail-value">{{ horse.passport_id || '-' }}</span>
        </div>
        <div class="detail-row">
          <span class="detail-label">{{ 'horseDetails.registryId' | translate }}</span>
          <span class="detail-value">{{ horse.horse_registry_id || '-' }}</span>
        </div>
      </div>
    </div>

    <!-- Health / Vaccination -->
    <div class="details-section">
      <h6 class="section-title">
        <i class="fa fa-heartbeat me-2"></i>
        {{ 'horseDetails.health' | translate }}
      </h6>
      <div class="details-list">
        <div class="detail-row">
          <span class="detail-label">{{ 'horseDetails.lastVaccination' | translate }}</span>
          <span class="detail-value">{{ formatDate(horse.vaccination_date) }}</span>
        </div>
        <div class="detail-row">
          <span class="detail-label">{{ 'horseDetails.nextVaccination' | translate }}</span>
          <span class="detail-value" [class.text-danger]="horse.next_vaccination_date && isVaccinationOverdue()">
            {{ formatDate(horse.next_vaccination_date) }}
            @if (horse.next_vaccination_date && isVaccinationOverdue()) {
              <i class="fa fa-exclamation-triangle ms-2"></i>
            }
          </span>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="modal-footer">
  <app-button
    [variant]="'outline'"
    [label]="'common.close' | translate"
    (clicked)="close()"
  />
</div>
